module.exports = __webpack_public_path__ + "static/media/third.c99cc67e.png";